export let VerificationType;

(function (VerificationType) {
  VerificationType["Google"] = "google";
  VerificationType["Microsoft"] = "microsoft";
  VerificationType["Email"] = "email";
  VerificationType["ExistingUser"] = "existing-user";
  VerificationType["ExistingUserExistingAccount"] = "existing-user-existing-account";
  VerificationType["EmailByCode"] = "email-by-code";
})(VerificationType || (VerificationType = {}));